(function () {
  'use strict';

  function addedProductQualifies(cart, requested, minimum) {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(minimum) || minimum < 0) return false;
    return (requested || []).some(function (added) {
      if (!(Number(added.quantity == null ? 1 : added.quantity) > 0)) return false;
      return cart.items.some(function (item) {
        var properties = item.properties || {};
        if (properties._gd_reward_gift === 'true' || properties._gota_brinde === 'true') return false;
        if (String(item.variant_id || item.id) !== String(added.id)) return false;
        var unitPrice = Number(item.final_price != null ? item.final_price : Number(item.final_line_price) / Number(item.quantity));
        return Number.isFinite(unitPrice) && unitPrice > minimum;
      });
    });
  }

  function discountForecast(cart, price, rules) {
    var codes = cart.discount_codes || [];
    var hasDiscounts = Number(cart.total_discount) > 0 || codes.length > 0;
    if (!Array.isArray(rules)) return hasDiscounts ? null : Number(cart.total_price) + price;
    if (Number(cart.total_discount) > 0 && rules.length === 0) return null;
    var grouped = new Map();
    rules.forEach(function (rule) {
      var key = JSON.stringify([rule.type, rule.title, rule.valueType, rule.value, rule.target, rule.allocation]);
      if (!grouped.has(key)) grouped.set(key, Object.assign({}, rule, { allocated: 0 }));
      grouped.get(key).allocated += Number(rule.allocated) || 0;
    });
    var discounts = Array.from(grouped.values());
    // Codes without exposed rules may become eligible with the new product.
    if (codes.some(function (code) {
      return !discounts.some(function (rule) {
        return rule.type === 'discount_code' && String(rule.title).toLowerCase() === String(code.code).toLowerCase();
      });
    })) return null;
    var percentage = 0;
    var fixed = 0;
    for (var rule of discounts) {
      if (rule.target === 'shipping_line') continue;
      var value = Number(rule.value);
      if (rule.target !== 'line_item' || !Number.isFinite(value) || value < 0 ||
          (rule.type !== 'discount_code' && rule.type !== 'automatic')) return null;
      // Entitlement cannot be predicted for a new variant through Ajax.
      // Applying every known rule is conservative: never assume the new item
      // is exempt just because it is not yet in the cart.
      if (rule.valueType === 'percentage' && value <= 100) percentage += value;
      else if (rule.valueType === 'fixed_amount' && ['across', 'each'].includes(rule.allocation)) {
        // Liquid fixed_amount values and allocations are already in cents.
        fixed += rule.allocation === 'each' ? value : Math.max(0, value - rule.allocated);
      } else return null;
    }
    var contribution = Math.max(0, price - Math.ceil(price * Math.min(100, percentage) / 100) - Math.ceil(fixed));
    return Number(cart.total_price) + contribution;
  }

  function cartPricingKey(cart) {
    return JSON.stringify([
      cart.total_price, cart.total_discount || 0, cart.currency,
      cart.discount_codes || [], cart.cart_level_discount_applications || [],
      (cart.items || []).map(function (item) {
        return [item.key, item.variant_id || item.id, item.quantity, item.final_line_price, item.line_level_discount_allocations || []];
      })
    ]);
  }

  function chooseOptions(cart, products, threshold, rules) {
    var total = Number(cart && cart.total_price);
    if (!Number.isFinite(total) || total < 0 || !(threshold > total)) return [];
    var existing = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
    var seen = new Set();
    return (products || []).reduce(function (options, product) {
      var productId = String(product.id || '');
      if (!productId || existing.has(productId) || seen.has(productId)) return options;
      var eligible = (product.variants || []).filter(function (variant) {
        return variant.available !== false && Number(variant.id) > 0 &&
          Number.isFinite(Number(variant.price)) && Number(variant.price) > 0 &&
          discountForecast(cart, Number(variant.price), rules) > threshold;
      }).sort(function (a, b) { return Number(a.price) - Number(b.price); });
      if (!eligible.length) return options;
      seen.add(productId);
      options.push({ product: product, variant: eligible[0], projectedTotal: discountForecast(cart, Number(eligible[0].price), rules) });
      return options;
    }, []).sort(function (a, b) { return a.variant.price - b.variant.price; }).slice(0, 3);
  }

  function shouldOffer(cart, requested, config) {
    return Boolean(config.enabled && config.shippingActive && config.collection &&
      !config.designMode && Number.isFinite(config.threshold) && config.threshold > 0 &&
      cart && Number.isFinite(cart.total_price) && cart.total_price < config.threshold &&
      addedProductQualifies(cart, requested, config.minimum));
  }

  if (window.__GD_ORDERBUMP_TEST_HOOK__) {
    window.__GD_ORDERBUMP_TEST_HOOK__({
      addedProductQualifies: addedProductQualifies, chooseOptions: chooseOptions, shouldOffer: shouldOffer,
      discountForecast: discountForecast, cartPricingKey: cartPricingKey
    });
  }

  var root = document.querySelector('[data-gd-orderbump]');
  var shared = window.GDThemeShared;
  if (!root || !shared || root.dataset.enabled !== 'true' || root.dataset.designMode === 'true') return;
  if (root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';
  var dialog = root.querySelector('[data-gd-orderbump-dialog]');
  var optionsHost = root.querySelector('[data-gd-orderbump-options]');
  var status = root.querySelector('[data-gd-orderbump-status]');
  var closeButton = root.querySelector('[data-gd-orderbump-close]');
  var remaining = root.querySelector('[data-gd-orderbump-remaining]');
  if (!dialog || !optionsHost || !status || !closeButton || !remaining) return;

  var config = {
    enabled: true,
    designMode: false,
    shippingActive: root.dataset.shippingActive === 'true',
    threshold: Number(root.dataset.shippingThreshold),
    minimum: Number(root.dataset.minProductPrice),
    collection: root.dataset.collectionHandle || ''
  };
  var revision = 0;
  var timer;
  var adding = false;
  var lastFocus = null;
  var pages = new Map();

  function finishClose() {
    document.documentElement.classList.remove('gd-orderbump-open');
    if (lastFocus && lastFocus.isConnected && !lastFocus.disabled) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function closeOffer() {
    if (adding) return;
    if (dialog.open) dialog.close();
  }

  closeButton.addEventListener('click', closeOffer);
  dialog.addEventListener('close', finishClose);
  dialog.addEventListener('cancel', function (event) { if (adding) event.preventDefault(); });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog || adding) return;
    var box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeOffer();
  });

  function handlePopupKeydown(event) {
    if (!dialog.open || (event.key !== 'Escape' && event.key !== 'Tab')) return;
    // The cart and menu also trap keys; only the topmost popup owns them.
    event.stopImmediatePropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      closeOffer();
      return;
    }
    var buttons = Array.from(dialog.querySelectorAll('button:not([disabled])'));
    if (!buttons.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = buttons[0], last = buttons[buttons.length - 1];
    if (!buttons.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
  document.addEventListener('keydown', handlePopupKeydown, true);

  function catalogPage(url, fresh) {
    var cached = pages.get(url);
    if (!fresh && cached && Date.now() - cached.created < 60000) return cached.promise;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 5000);
    var promise = fetch(url, {
      credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('A coleção não respondeu.');
      return response.text();
    }).then(function (html) {
      var fragment = new DOMParser().parseFromString(html, 'text/html');
      var catalog = fragment.querySelector('[data-gd-orderbump-catalog]');
      if (!catalog) throw new Error('Os dados do OrderBump não estão instalados no tema.');
      return {
        cartTotal: Number(catalog.dataset.cartTotal),
        cartDiscount: Number(catalog.dataset.cartDiscount),
        currency: catalog.dataset.cartCurrency,
        discounts: Array.from(catalog.querySelectorAll('[data-gd-ob-discount]')).map(function (node) {
          return {
            type: node.dataset.type, title: node.dataset.title, valueType: node.dataset.valueType,
            value: Number(node.dataset.value), target: node.dataset.target,
            allocation: node.dataset.allocation, allocated: Number(node.dataset.allocated) || 0
          };
        }),
        next: catalog.dataset.nextUrl || '',
        products: Array.from(catalog.querySelectorAll('[data-gd-ob-product]')).map(function (node) {
          return {
            id: node.dataset.productId, title: node.dataset.title, image: node.dataset.image,
            variants: Array.from(node.querySelectorAll('[data-gd-ob-variant]')).map(function (variant) {
              return { id: Number(variant.dataset.variantId), price: Number(variant.dataset.price), title: variant.dataset.title, available: true };
            })
          };
        })
      };
    }).catch(function (error) {
      if (pages.get(url) && pages.get(url).promise === promise) pages.delete(url);
      throw error;
    }).finally(function () { window.clearTimeout(timeout); });
    pages.set(url, { created: Date.now(), promise: promise });
    return promise;
  }

  async function loadOptions(cart, expectedRevision) {
    var url = new URL(shared.rootUrl + 'collections/' + encodeURIComponent(config.collection), window.location.origin);
    url.searchParams.set('section_id', 'gd-orderbump-catalog');
    var visited = new Set();
    var products = [];
    var rules;
    while (url && !visited.has(url.href) && visited.size < 100) {
      if (expectedRevision !== revision) return [];
      visited.add(url.href);
      var page = await catalogPage(url.href, visited.size === 1);
      if (expectedRevision !== revision) return [];
      if (visited.size === 1) {
        // Only catalog data may be cached; coupon rules belong to this cart.
        if (Number.isFinite(page.cartTotal) && (page.cartTotal !== cart.total_price ||
            page.cartDiscount !== Number(cart.total_discount || 0) ||
            (page.currency && page.currency !== cart.currency))) return [];
        rules = page.discounts;
      }
      products = products.concat(page.products);
      var options = chooseOptions(cart, products, config.threshold, rules);
      if (options.length === 3) return options;
      if (!page.next) return [];
      var next = new URL(page.next, url);
      if (next.origin !== window.location.origin || next.pathname !== url.pathname) throw new Error('Paginação inválida da coleção.');
      next.searchParams.set('section_id', 'gd-orderbump-catalog');
      url = next;
    }
    return [];
  }

  function setBusy(busy) {
    adding = busy;
    dialog.setAttribute('aria-busy', String(busy));
    root.querySelectorAll('button').forEach(function (button) { button.disabled = busy; });
  }

  function renderOption(option, cart) {
    var article = document.createElement('article');
    article.className = 'gd-orderbump__product';
    if (option.product.image) {
      var image = document.createElement('img');
      image.className = 'gd-orderbump__image';
      image.src = option.product.image;
      image.alt = option.product.title;
      image.width = 80; image.height = 80;
      article.appendChild(image);
    } else article.setAttribute('data-no-image', '');
    var details = document.createElement('div');
    details.className = 'gd-orderbump__details';
    var title = document.createElement('strong');
    title.className = 'gd-orderbump__name';
    title.textContent = option.product.title;
    details.appendChild(title);
    if (option.variant.title && option.variant.title !== 'Default Title') {
      var variant = document.createElement('small');
      variant.className = 'gd-orderbump__variant';
      variant.textContent = option.variant.title;
      details.appendChild(variant);
    }
    var price = document.createElement('strong');
    price.className = 'gd-orderbump__price';
    price.textContent = shared.money(option.variant.price, cart.currency);
    details.appendChild(price);
    if (Number(cart.total_discount) > 0 || (cart.discount_codes || []).length) {
      var estimate = document.createElement('small');
      estimate.className = 'gd-orderbump__variant';
      estimate.textContent = 'Subtotal estimado com os descontos atuais: ' + shared.money(option.projectedTotal, cart.currency);
      details.appendChild(estimate);
    }
    article.appendChild(details);
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'gd-orderbump__add';
    add.textContent = 'Adicionar';
    add.setAttribute('aria-label', 'Adicionar ' + option.product.title);
    add.addEventListener('click', async function () {
      if (adding) return;
      setBusy(true);
      status.classList.remove('is-error');
      add.textContent = 'Adicionando…';
      add.setAttribute('aria-label', 'Adicionando ' + option.product.title);
      status.textContent = 'Adicionando o produto ao carrinho…';
      try {
        var updated = await shared.gdCart.add([{ id: option.variant.id, quantity: 1 }], {
          source: 'orderbump',
          beforeAdd: function (current) {
            // This check runs inside the cart write queue, not before it.
            if (cartPricingKey(current) !== cartPricingKey(cart)) {
              var stale = new Error('O carrinho ou o cupom mudou. Confira a nova meta antes de adicionar.');
              stale.staleCart = current;
              throw stale;
            }
          }
        });
        if (document.querySelector('[data-gd-cart-drawer].is-open')) shared.renderDrawerFast(updated);
        setBusy(false);
        closeOffer();
        shared.showToast(updated.total_price >= config.threshold
          ? 'Produto adicionado ao carrinho.'
          : 'Produto adicionado. Ainda faltam ' + shared.money(Math.max(0, config.threshold - updated.total_price), updated.currency) + ' para FRETE GRÁTIS após os descontos.');
      } catch (error) {
        setBusy(false);
        if (error.staleCart) {
          closeOffer();
          shared.setCartCount(error.staleCart.item_count);
          document.dispatchEvent(new CustomEvent('gd:cart:updated', { detail: { cart: error.staleCart } }));
          shared.renderDrawerFast(error.staleCart);
          shared.showToast(error.message);
          return;
        }
        status.classList.add('is-error');
        status.textContent = error.message || 'Não foi possível adicionar. Tente novamente.';
        add.textContent = 'Adicionar';
        add.setAttribute('aria-label', 'Adicionar ' + option.product.title);
      }
    });
    article.appendChild(add);
    return article;
  }

  async function offer(detail, expectedRevision) {
    if (!shouldOffer(detail.cart, detail.items, config) || adding || dialog.open) return;
    try {
      var current = await shared.request(shared.rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (expectedRevision !== revision || !shouldOffer(current, detail.items, config)) return;
      detail = Object.assign({}, detail, { cart: current });
      var options = await loadOptions(detail.cart, expectedRevision);
      if (expectedRevision !== revision || options.length !== 3 || adding || dialog.open) return;
      if (document.querySelector('dialog[open]') || typeof dialog.showModal !== 'function') return;
      optionsHost.replaceChildren();
      options.forEach(function (option) { optionsHost.appendChild(renderOption(option, detail.cart)); });
      remaining.textContent = 'Faltam ' + shared.money(config.threshold - detail.cart.total_price, detail.cart.currency) +
        ' para FRETE GRÁTIS após os descontos. As opções consideram os descontos atuais; a condição final é confirmada no checkout.';
      status.textContent = '';
      status.classList.remove('is-error');
      setBusy(false);
      lastFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('gd-orderbump-open');
      var firstAction = optionsHost.querySelector('button');
      if (firstAction) firstAction.focus({ preventScroll: true });
    } catch (error) {
      // The purchase succeeded; optional offers must not turn it into an error.
      console.warn('OrderBump indisponível:', error.message);
    }
  }

  document.addEventListener('gd:cart:updated', function () {
    revision += 1;
    window.clearTimeout(timer);
    if (dialog.open && !adding) closeOffer();
  });
  document.addEventListener('gd:cart:added', function (event) {
    var detail = event.detail;
    if (!detail || detail.source === 'orderbump' || detail.source === 'kit-suggestion' || detail.kitSuggestionClaimed || !shouldOffer(detail.cart, detail.items, config)) return;
    window.clearTimeout(timer);
    var expectedRevision = revision;
    // Let the normal add-to-cart response and any automatic drawer opening finish.
    Promise.resolve(detail.kitSuggestionLookup).then(function () {
      if (expectedRevision !== revision || detail.kitSuggestionClaimed) return;
      timer = window.setTimeout(function () { offer(detail, expectedRevision); }, 0);
    });
  });
})();
